// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__8ZaIh","image":"styles_image__sU5X9","text":"styles_text__q9FaR"};